import { landing } from './landing.js'
import { booking } from './booking.js'
import { dashboard } from './dashboard.js'
import { patient } from './patient.js'
import { patients } from './patients.js'
import { ai } from './ai.js'
import { clinics } from './clinics.js'
import { clinic } from './clinic.js'
import { business } from './business.js'
import { scheduling } from './scheduling.js'
import { billing } from './billing.js'
import { prescriptions } from './prescriptions.js'
import { labCases } from './labCases.js'
import { referrals } from './referrals.js'
import { reports } from './reports.js'
import { enterprise } from './enterprise.js'
import { integrations } from './integrations.js'
import { finances } from './finances.js'
import { pitch } from './pitch.js'
import { chat } from './chat.js'
import { consent } from './consent.js'
import { cabinets } from './cabinets.js'
import { documents } from './documents.js'
import { inventory } from './inventory.js'
import { radiology } from './radiology.js'
import { staff } from './staff.js'
import { mySchedule } from './mySchedule.js'
import { templates } from './templates.js'
import { formBuilder } from './formBuilder.js'
import { consentTemplates } from './consentTemplates.js'

export default {
  '/': landing,
  '/booking': booking,
  '/dashboard': dashboard,
  '/patient': patient,
  '/patients': patients,
  '/ai': ai,
  '/clinics': clinics,
  '/clinic': clinic,
  '/business': business,
  // Clinical pages merged into /patient
  '/chart': patient,
  '/perio': patient,
  '/treatment-plan': patient,
  '/clinical-notes': patient,
  '/medical-history': patient,
  // Operations
  '/scheduling': scheduling,
  '/billing': billing,
  '/prescriptions': prescriptions,
  '/lab-cases': labCases,
  '/referrals': referrals,
  '/reports': reports,
  '/enterprise': enterprise,
  '/finances': finances,
  '/integrations': integrations,
  '/pitch': pitch,
  '/chat': chat,
  '/consent': consent,
  '/cabinets': cabinets,
  '/documents': documents,
  '/radiology': radiology,
  '/inventory': inventory,
  '/staff': staff,
  '/my-schedule': mySchedule,
  // Templates
  '/templates': templates,
  '/templates/forms': formBuilder,
  '/templates/consent': consentTemplates
}
